/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Componente_Q1_81_49 as Componente_Q1_81_49,
  rec_FotosActa as FotosActa,
  rec_I1 as I1,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_RespuestaActa as RespuestaActa,
  rec_SeguimientoObservaciones as SeguimientoObservaciones,
  rec_i0 as i0,
  rec_y1 as y1,
  rec_z1 as z1,
} from "../../runtime/index.jsx";
export function DetalleActa(e) {
  let t = (0, ReactCompiler.c)(94),
    { acta: n, datos: r, onEditar: i, pasoDelItem: a } = e,
    o;
  t[0] === a
    ? (o = t[1])
    : ((o = a === void 0 ? {} : a), (t[0] = a), (t[1] = o));
  let s = o,
    c = n.plantilla.items,
    l;
  t[2] === r
    ? (l = t[3])
    : ((l = (e) => r.items?.[e.id]?.valor), (t[2] = r), (t[3] = l));
  let u = l,
    d;
  t[4] === u
    ? (d = t[5])
    : ((d = (e) => {
        let t = u(e);
        return Array.isArray(t) ? t.length > 0 : t != null && t !== ``;
      }),
      (t[4] = u),
      (t[5] = d));
  let f = d,
    p,
    m,
    h,
    _,
    v,
    y,
    b,
    x,
    S,
    C;
  if (
    t[6] !== n ||
    t[7] !== r ||
    t[8] !== c ||
    t[9] !== i ||
    t[10] !== s ||
    t[11] !== f ||
    t[12] !== u
  ) {
    let e;
    t[23] === u
      ? (e = t[24])
      : ((e = (e) => z1(e, u(e))), (t[23] = u), (t[24] = e));
    let a = c.filter(e),
      o;
    if (t[25] !== c || t[26] !== f) {
      let e;
      (t[28] === f
        ? (e = t[29])
        : ((e = (e) => !f(e)), (t[28] = f), (t[29] = e)),
        (o = c.filter(e)),
        (t[25] = c),
        (t[26] = f),
        (t[27] = o));
    } else o = t[27];
    let l = o.length,
      d = c.length - a.length - l;
    m = [];
    for (let e of c) {
      let t = e.seccion || `Puntos de revisión`,
        n = m.at(-1);
      n && n.nombre === t
        ? n.items.push(e)
        : m.push({
            nombre: t,
            items: [e],
          });
    }
    let g;
    (t[30] === n.archivos
      ? (g = t[31])
      : ((g = n.archivos.filter(i0)), (t[30] = n.archivos), (t[31] = g)),
      (p = g),
      (S = `space-y-4`));
    let w;
    t[32] === d
      ? (w = t[33])
      : ((w = (
          <p
            className={`text-2xl font-semibold text-(--success)`}
            children={d}
          />
        )),
        (t[32] = d),
        (t[33] = w));
    let T;
    t[34] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((T = (
          <p className={`text-[11px] text-(--text)`} children={`En regla`} />
        )),
        (t[34] = T))
      : (T = t[34]);
    let E;
    t[35] === w
      ? (E = t[36])
      : ((E = <div className={`${I1} text-center`} children={[w, T]} />),
        (t[35] = w),
        (t[36] = E));
    let D;
    t[37] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((D = (
          <p
            className={`text-[11px] text-(--text)`}
            children={`Por levantar`}
          />
        )),
        (t[37] = D))
      : (D = t[37]);
    let O = (
        <div
          className={`${I1} text-center`}
          children={[
            <p
              className={`text-2xl font-semibold ${a.length ? `text-(--error)` : `text-(--text-h)`}`}
              children={a.length}
            />,
            D,
          ]}
        />
      ),
      k = `text-2xl font-semibold ${l ? `text-(--warning)` : `text-(--text-h)`}`,
      A;
    t[38] !== l || t[39] !== k
      ? ((A = <p className={k} children={l} />),
        (t[38] = l),
        (t[39] = k),
        (t[40] = A))
      : (A = t[40]);
    let j;
    t[41] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((j = (
          <p
            className={`text-[11px] text-(--text)`}
            children={`Sin responder`}
          />
        )),
        (t[41] = j))
      : (j = t[41]);
    let M;
    (t[42] === A
      ? (M = t[43])
      : ((M = <div className={`${I1} text-center`} children={[A, j]} />),
        (t[42] = A),
        (t[43] = M)),
      t[44] !== E || t[45] !== O || t[46] !== M
        ? ((C = (
            <div className={`grid grid-cols-3 gap-2`} children={[E, O, M]} />
          )),
          (t[44] = E),
          (t[45] = O),
          (t[46] = M),
          (t[47] = C))
        : (C = t[47]));
    let N;
    t[48] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((N = <dt className={`text-xs text-(--text)`} children={`Dónde`} />),
        (t[48] = N))
      : (N = t[48]);
    let P;
    t[49] !== n.fundoNombre || t[50] !== n.unidadNombre
      ? ((P = [n.unidadNombre, n.fundoNombre].filter(Boolean)),
        (t[49] = n.fundoNombre),
        (t[50] = n.unidadNombre),
        (t[51] = P))
      : (P = t[51]);
    let F = P.join(` · `),
      I;
    t[52] === F
      ? (I = t[53])
      : ((I = (
          <div
            className={`col-span-2`}
            children={[
              N,
              <dd className={`break-words text-(--text-h)`} children={F} />,
            ]}
          />
        )),
        (t[52] = F),
        (t[53] = I));
    let L;
    if (t[54] !== n.plantilla.cabecera || t[55] !== r.cabecera) {
      let e;
      (t[57] === r.cabecera
        ? (e = t[58])
        : ((e = (e) => (
            <div
              key={e.id}
              className={`min-w-0`}
              children={[
                <dt
                  className={`text-xs text-(--text)`}
                  children={e.etiqueta}
                />,
                <dd
                  className={`break-words text-(--text-h)`}
                  children={r.cabecera?.[e.id] || `Sin completar`}
                />,
              ]}
            />
          )),
          (t[57] = r.cabecera),
          (t[58] = e)),
        (L = n.plantilla.cabecera.map(e)),
        (t[54] = n.plantilla.cabecera),
        (t[55] = r.cabecera),
        (t[56] = L));
    } else L = t[56];
    (t[59] !== I || t[60] !== L
      ? ((h = (
          <dl
            className={`grid grid-cols-2 gap-x-3 gap-y-2 text-sm`}
            children={[I, L]}
          />
        )),
        (t[59] = I),
        (t[60] = L),
        (t[61] = h))
      : (h = t[61]),
      t[62] === i
        ? (_ = t[63])
        : ((_ = i && (
            <AccionAsync
              variante={`texto`}
              className={`min-h-11`}
              onClick={() => i(0)}
              children={`Editar datos de la inspección`}
            />
          )),
          (t[62] = i),
          (t[63] = _)),
      (v = a.length > 0 && (
        <section
          className={`space-y-2`}
          children={[
            <p
              className={`text-sm font-semibold text-(--text-h)`}
              children={`⚠️ Por levantar`}
            />,
            a.map((e) => {
              let t = r.items?.[e.id] || {};
              return (
                <div
                  key={e.id}
                  className={`space-y-2 rounded-xl border border-(--warning-border) bg-(--warning-bg) p-3 text-sm`}
                  children={[
                    <div
                      className={`flex items-start justify-between gap-2`}
                      children={[
                        <p
                          className={`font-medium text-(--text-h)`}
                          children={e.etiqueta}
                        />,
                        i && (
                          <AccionAsync
                            variante={`texto`}
                            className={`min-h-11 shrink-0`}
                            onClick={() => i(s[e.id] ?? 1)}
                            children={`Editar`}
                          />
                        ),
                      ]}
                    />,
                    Array.isArray(t.valor) && (
                      <p
                        className={`text-xs text-(--text)`}
                        children={t.valor.join(`, `)}
                      />
                    ),
                    t.observacion && (
                      <p
                        className={`break-words text-(--text-h)`}
                        children={t.observacion}
                      />
                    ),
                    <p
                      className={`break-words`}
                      children={[
                        <span
                          className={`text-xs text-(--text)`}
                          children={`Acción: `}
                        />,
                        t.accion || `Falta indicar la acción`,
                      ]}
                    />,
                    <p
                      className={`text-xs text-(--text)`}
                      children={[
                        t.responsable || `Sin responsable`,
                        ` · `,
                        t.fechaCompromiso || `Sin fecha de levantamiento`,
                      ]}
                    />,
                    <Componente_Q1_81_49 acta={n} campo={`foto:${e.id}`} />,
                  ]}
                />
              );
            }),
          ]}
        />
      )),
      (y = `space-y-2`),
      t[64] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((b = (
            <p
              className={`text-sm font-semibold text-(--text-h)`}
              children={`Lo revisado`}
            />
          )),
          (t[64] = b))
        : (b = t[64]),
      (x = m.map((e) => {
        let t = e.items.filter((e) => z1(e, u(e))).length;
        return (
          <details
            key={e.nombre}
            className={`rounded-xl border border-(--border)`}
            children={[
              <summary
                className={`flex min-h-11 cursor-pointer items-center justify-between gap-2 px-3 text-sm`}
                children={[
                  <span
                    className={`min-w-0 truncate font-medium text-(--text-h)`}
                    children={[
                      <span
                        aria-hidden={`true`}
                        children={[y1(e.nombre), ` `]}
                      />,
                      e.nombre,
                    ]}
                  />,
                  <span
                    className={`shrink-0 text-xs text-(--text)`}
                    children={[
                      e.items.length,
                      ` puntos`,
                      t ? ` · ${t} ⚠️` : ` · ✅`,
                      (() => {
                        let t = n.archivos.filter((t) =>
                          e.items.some((e) => t.campo === `foto:${e.id}`),
                        ).length;
                        return t ? ` · 📷 ${t}` : ``;
                      })(),
                    ]}
                  />,
                ]}
              />,
              <ul
                className={`divide-y divide-(--border) border-t border-(--border)`}
                children={e.items.map((e) => {
                  let t = r.items?.[e.id] || {};
                  return (
                    <li
                      key={e.id}
                      className={`space-y-2 px-3 py-2 text-sm`}
                      children={[
                        <div
                          className={`flex items-center justify-between gap-2`}
                          children={[
                            <span
                              className={`min-w-0 text-(--text-h)`}
                              children={e.etiqueta}
                            />,
                            <RespuestaActa item={e} valor={t.valor} />,
                          ]}
                        />,
                        t.observacion && !z1(e, t.valor) && (
                          <p
                            className={`break-words text-xs text-(--text)`}
                            children={t.observacion}
                          />
                        ),
                        t.vigencia && (
                          <p
                            className={`text-xs text-(--text)`}
                            children={[`Vigente hasta `, t.vigencia]}
                          />
                        ),
                      ]}
                    />
                  );
                })}
              />,
            ]}
          />
        );
      })),
      (t[6] = n),
      (t[7] = r),
      (t[8] = c),
      (t[9] = i),
      (t[10] = s),
      (t[11] = f),
      (t[12] = u),
      (t[13] = p),
      (t[14] = m),
      (t[15] = h),
      (t[16] = _),
      (t[17] = v),
      (t[18] = y),
      (t[19] = b),
      (t[20] = x),
      (t[21] = S),
      (t[22] = C));
  } else
    ((p = t[13]),
      (m = t[14]),
      (h = t[15]),
      (_ = t[16]),
      (v = t[17]),
      (y = t[18]),
      (b = t[19]),
      (x = t[20]),
      (S = t[21]),
      (C = t[22]));
  let w;
  t[65] !== y || t[66] !== b || t[67] !== x
    ? ((w = <section className={y} children={[b, x]} />),
      (t[65] = y),
      (t[66] = b),
      (t[67] = x),
      (t[68] = w))
    : (w = t[68]);
  let T;
  t[69] !== n || t[70] !== r || t[71] !== p || t[72] !== m
    ? ((T = <FotosActa acta={n} datos={r} secciones={m} generales={p} />),
      (t[69] = n),
      (t[70] = r),
      (t[71] = p),
      (t[72] = m),
      (t[73] = T))
    : (T = t[73]);
  let E;
  t[74] !== n || t[75] !== r.firmantes
    ? ((E = r.firmantes?.length > 0 && (
        <section
          className={`space-y-2`}
          children={[
            <p
              className={`text-sm font-semibold text-(--text-h)`}
              children={`✍️ Firmas`}
            />,
            <div
              className={`grid gap-3 sm:grid-cols-2`}
              children={n.plantilla.firmas.map((e, t) => (
                <div
                  key={e}
                  className={`space-y-1 text-sm`}
                  children={[
                    <p className={`text-xs text-(--text)`} children={e} />,
                    <p
                      className={`text-(--text-h)`}
                      children={r.firmantes[t] || `Sin completar`}
                    />,
                    <Componente_Q1_81_49
                      acta={n}
                      campo={`firma:${t}`}
                      alto={`h-16`}
                    />,
                  ]}
                />
              ))}
            />,
          ]}
        />
      )),
      (t[74] = n),
      (t[75] = r.firmantes),
      (t[76] = E))
    : (E = t[76]);
  let D;
  t[77] !== n.estado || t[78] !== n.id
    ? ((D = n.estado === `CERRADA` && (
        <SeguimientoObservaciones actaId={n.id} />
      )),
      (t[77] = n.estado),
      (t[78] = n.id),
      (t[79] = D))
    : (D = t[79]);
  let O;
  t[80] !== n.cerradaEn || t[81] !== n.plantilla.version
    ? ((O = n.cerradaEn && (
        <p
          className={`text-xs text-(--text)`}
          children={[
            `Cerrada el `,
            new Date(n.cerradaEn).toLocaleString(`es-PE`),
            `. Versión `,
            n.plantilla.version,
            ` del acta.`,
          ]}
        />
      )),
      (t[80] = n.cerradaEn),
      (t[81] = n.plantilla.version),
      (t[82] = O))
    : (O = t[82]);
  let k;
  return (
    t[83] !== h ||
    t[84] !== _ ||
    t[85] !== v ||
    t[86] !== w ||
    t[87] !== T ||
    t[88] !== E ||
    t[89] !== D ||
    t[90] !== O ||
    t[91] !== S ||
    t[92] !== C
      ? ((k = <div className={S} children={[C, h, _, v, w, T, E, D, O]} />),
        (t[83] = h),
        (t[84] = _),
        (t[85] = v),
        (t[86] = w),
        (t[87] = T),
        (t[88] = E),
        (t[89] = D),
        (t[90] = O),
        (t[91] = S),
        (t[92] = C),
        (t[93] = k))
      : (k = t[93]),
    k
  );
}
